// IndexedDB cache for the D&D Beyond monster catalogue (thousands of rows are
// too big for the layout document). One record per profile.
export interface MonsterRecord { id: string; name: string; cr: string; crValue: number; type: string; source: string; sourceUrl: string; thirdParty: boolean; homebrew: boolean }
export interface MonsterCatalog { items: MonsterRecord[]; syncedAt: string; partial: boolean; officialCount: number; homebrewCount: number; accountFingerprint?: string }

const DB = "dm-screen-next-cache", STORE = "monster-catalog";
function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => { req.result.createObjectStore(STORE); };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}
export async function loadCatalog(profileId: string): Promise<MonsterCatalog | null> {
  try { const db = await open(); return await new Promise((resolve) => { const r = db.transaction(STORE).objectStore(STORE).get(profileId); r.onsuccess = () => resolve(r.result || null); r.onerror = () => resolve(null); }); }
  catch { return null; }
}
export async function saveCatalog(profileId: string, catalog: MonsterCatalog) {
  try { const db = await open(); await new Promise<void>((resolve) => { const tx = db.transaction(STORE, "readwrite"); tx.objectStore(STORE).put(catalog, profileId); tx.oncomplete = () => resolve(); tx.onerror = () => resolve(); }); }
  catch { /* private mode: the catalogue just is not cached */ }
}
export async function clearCatalog(profileId: string) {
  try { const db = await open(); await new Promise<void>((resolve) => { const tx = db.transaction(STORE, "readwrite"); tx.objectStore(STORE).delete(profileId); tx.oncomplete = () => resolve(); tx.onerror = () => resolve(); }); } catch { /* ignore */ }
}
